import React, { useEffect, useRef } from "react";

const FilterDropdown = ({
  onFilterClick,
  setShowFilters,
  selectedFilter,
  setSelectedFilter,
}) => {
  const dropdownRef = useRef(null);

  const filters = [
    { value: "", label: "Default" },
    { value: "oldChats", label: "Old Chats First" },
    { value: "alphabetical", label: "Alphabetical" },
    { value: "startDate", label: "Start Date" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowFilters(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowFilters]); // Only include setShowFilters in dependencies

  const handleFilterClick = (filterValue) => {
    setSelectedFilter(filterValue);
    onFilterClick(filterValue);
    setShowFilters(false);
  };

  return (
    <div
      ref={dropdownRef}
      className="absolute right-0 mt-2 w-48 bg-white shadow-lg rounded-md p-3 z-10 border border-gray-100"
    >
      <div className="flex justify-between items-center mb-2">
        <p className="text-sm font-semibold text-gray-700">Filters</p>
      </div>
      {}
      <div className="flex flex-col gap-1">
        {filters?.map((filter) => (
          <button
            key={filter.value}
            className={`text-left px-3 py-2 rounded text-sm ${
              selectedFilter === filter.value
                ? "bg-gray-100 font-medium"
                : "hover:bg-gray-50"
            }`}
            onClick={() => handleFilterClick(filter.value)}
          >
            {filter.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterDropdown;
